/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AbstractControl } from '@angular/forms';
import {
  ApplicationState,
  ApplicationStateFactory,
  ApplicationStateHolder,
  FormArraySchemaConfig,
  FormControlSchemaConfig,
  FormGroupSchemaConfig, FormNativeSchemaConfig,
  FormRootSchemaConfig,
  FormState,
  FormStateSchema,
} from '@gh/common-shared';
import { isNil } from 'lodash';
import { BuilderFormArraySchema } from './builder-form-array-schema';
import { BuilderFormControlSchema } from './builder-form-control-schema';
import { BuilderFormGroupSchema } from './builder-form-group-schema';
import { BuilderFormNativeSchema } from './builder-form-native-schema';
import { BuilderFormRootSchema } from './builder-form-root-schema';

export class BuilderFormStateSchema implements ApplicationStateHolder, FormStateSchema {
  private _state?: ApplicationState;

  constructor(private appStateFactory: ApplicationStateFactory) {
    this.root = this.root.bind(this);
    this.group = this.group.bind(this);
    this.array = this.array.bind(this);
    this.control = this.control.bind(this);
    this.native = this.native.bind(this);
  }

  get state(): ApplicationState {
    if (isNil(this._state)) {
      throw new Error('Form state schema is not initialized');
    }

    return this._state;
  }

  init(formState: FormState<any>): void {
    if (!isNil(formState)) {
      this._state = this.appStateFactory.createByForm(formState);
    }
  }

  useState(state: ApplicationState): void {
    this._state = state;
  }

  root(config: FormRootSchemaConfig): BuilderFormRootSchema {
    const schema = new BuilderFormRootSchema(this);
    schema.update(config);
    return schema;
  }

  group(config: FormGroupSchemaConfig): BuilderFormGroupSchema {
    const schema = new BuilderFormGroupSchema(this);
    schema.update(config);
    return schema;
  }

  array(config: FormArraySchemaConfig): BuilderFormArraySchema {
    const schema = new BuilderFormArraySchema(this);
    schema.update(config);
    return schema;
  }

  control(config: FormControlSchemaConfig): BuilderFormControlSchema {
    const schema = new BuilderFormControlSchema(this);
    schema.update(config);
    return schema;
  }

  native(controlOrConfig: AbstractControl | FormNativeSchemaConfig): BuilderFormNativeSchema {
    const oonfig = controlOrConfig instanceof AbstractControl ? { control: controlOrConfig } : controlOrConfig;
    const schema = new BuilderFormNativeSchema(this);
    schema.update(oonfig);
    return schema;
  }
}
